import React from "react"
import { ExtendedApplicationDoc } from "../types/applicationData"

interface ConfirmModalProps {
  isOpen: boolean
  onClose: () => void
  selectedApplication: ExtendedApplicationDoc | null
  applicationStateChange: ((application: ExtendedApplicationDoc) => Promise<void>) | null
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  isOpen,
  onClose,
  selectedApplication,
  applicationStateChange,
}) => {
  if (!isOpen) {
    return null
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded shadow-xl w-80">
        <h2 className="text-lg font-semibold mb-4">Dikkat!</h2>
        <p className="text-sm text-gray-600 mb-6">
          Bu başvurunun durumunu belirtilen duruma taşımak istediğinize emin misiniz?
        </p>

        <div className="flex justify-end gap-3">
          <button className="px-3 py-1 bg-gray-200 rounded" onClick={() => onClose()}>
            Hayır
          </button>

          <button
            className="px-3 py-1 bg-red-600 text-white rounded"
            onClick={async () => {
              if (!applicationStateChange || !selectedApplication) {
                return
              }

              try {
                await applicationStateChange(selectedApplication)
              } catch (error) {
                alert("Uygulama durumu düşürülürken hata oluştu")
              }
            }}
          >
            Evet
          </button>
        </div>
      </div>
    </div>
  )
}

export default ConfirmModal
